// extracted by mini-css-extract-plugin
export default {"header-logo":"styles_header-logo__cQdHH"};